//GET REQUEST TYPES
export const PRODUCTS_REQUEST = "products/request";
export const PRODUCTS_ERROR = "products/error";
export const GET_PRODUCTS_SUCCESS = "get/products/success";

// POST REQUEST TYPES
export const POST_PRODUCTS_SUCCESS = "post/products/success";

//PATCH REQUEST
export const UPDATE_PRODUCTS = "patch/products/success";